// eslint-disable-next-line import/named
import { signInWithEmailAndPassword, User } from "firebase/auth";
import { auth } from "../../config/firebase";

// Response ----------

export type signInUsingFirebaseBody = {
  email: string;
  password: string;
};

// export type signinResponse = {};

// Request ----------

export async function signInUsingFirebase(
  body: signInUsingFirebaseBody
): Promise<User> {
  try {
    const response = await signInWithEmailAndPassword(
      auth,
      body.email,
      body.password
    );
    return response.user;
  } catch (error: unknown) {
    throw new Error(`signin - ${error as string}`);
  }
}
